import { Divider, Layout } from 'antd'
import TopHeader from './components/TopHeader'
import './styles.scss'
import ROUTER from '@/routes/ROUTER'
import { useLocation } from 'react-router-dom'

const { Header } = Layout

const HeaderMain = () => {
  const location = useLocation()
  if (
    [
      ROUTER.DANG_KY_LICH_HOP,
      ROUTER.HOME,
      ROUTER.DANG_KY_KHACH,
      ROUTER.LICH_HOP_CUA_TOI,
      ROUTER.DANG_KY_RA_VAO,
    ]?.includes(location.pathname)
  ) {
    return <></>
  }
  return (
    <div className="header-main">
      <Header style={{ background: 'transparent', padding: '3px 4px' }}>
        <div className="p-0">
          <TopHeader />
        </div>
      </Header>
      <Divider className="m-0 p-0" />
    </div>
  )
}

export default HeaderMain
